<template>
  <div class="homepage">
    <div class="btn">
      <el-button type="primary" @click="save">保存</el-button>
    </div>
    <div class="auto-table-flex">
      <div class="homepagecnt">
        <div class="box1">
          <div class="box1-title">首页背景图</div>

          <div style="display: flex">
            <div>
              <div style="margin-bottom: 5px">
                请上传尺寸为：750x296的图片；
              </div>
              <div style="margin-bottom: 10px">
                <el-upload
                  element-loading-text="正在上传..."
                  action="#"
                  :on-preview="handlePictureCardPreview"
                  :before-upload="
                    (file) => {
                      return handleBeforeUpload(file, 750, 296);
                    }
                  "
                  :class="{ hide: homepage1.length == 1 }"
                  :file-list="homepage1"
                  list-type="picture-card"
                  :http-request="
                    (file) => {
                      return uploadFile(file, 'homepage1');
                    }
                  "
                  :before-remove="
                    (file, fileList) => {
                      return deleteFile(file, fileList, 'homepage1');
                    }
                  "
                  :limit="1"
                >
                  <i slot="trigger" class="el-icon-plus"></i>
                </el-upload>
              </div>
            </div>
            <div>
              <div style="margin-bottom: 5px">
                请上传尺寸为：750x342的图片；
              </div>
              <div style="margin-bottom: 10px">
                <el-upload
                  element-loading-text="正在上传..."
                  action="#"
                  :on-preview="handlePictureCardPreview"
                  :before-upload="
                    (file) => {
                      return handleBeforeUpload(file, 750, 342);
                    }
                  "
                  :class="{ hide: homepage2.length == 1 }"
                  :file-list="homepage2"
                  list-type="picture-card"
                  :http-request="
                    (file) => {
                      return uploadFile(file, 'homepage2');
                    }
                  "
                  :before-remove="
                    (file, fileList) => {
                      return deleteFile(file, fileList, 'homepage2');
                    }
                  "
                  :limit="1"
                >
                  <i slot="trigger" class="el-icon-plus"></i>
                </el-upload>
              </div>
            </div>
          </div>

          <div class="box1-title">首页logo图</div>
          <div style="margin-bottom: 5px">请上传尺寸为：372x50的图片；</div>
          <div style="margin-bottom: 10px">
            <el-upload
              element-loading-text="正在上传..."
              action="#"
              :on-preview="handlePictureCardPreview"
              :before-upload="
                (file) => {
                  return handleBeforeUpload(file, 372, 50);
                }
              "
              :class="{ hide: homepage3.length == 1 }"
              :file-list="homepage3"
              list-type="picture-card"
              :http-request="
                (file) => {
                  return uploadFile(file, 'homepage3');
                }
              "
              :before-remove="
                (file, fileList) => {
                  return deleteFile(file, fileList, 'homepage3');
                }
              "
              :limit="1"
            >
              <i slot="trigger" class="el-icon-plus"></i>
            </el-upload>
          </div>

          <div class="box1-title">我的页面背景图</div>

          <div style="display: flex">
            <div>
              <div style="margin-bottom: 5px">
                请上传尺寸为：750x194的图片；
              </div>
              <div style="margin-bottom: 10px">
                <el-upload
                  element-loading-text="正在上传..."
                  action="#"
                  :on-preview="handlePictureCardPreview"
                  :before-upload="
                    (file) => {
                      return handleBeforeUpload(file, 750, 194);
                    }
                  "
                  :class="{ hide: mypage1.length == 1 }"
                  :file-list="mypage1"
                  list-type="picture-card"
                  :http-request="
                    (file) => {
                      return uploadFile(file, 'mypage1');
                    }
                  "
                  :before-remove="
                    (file, fileList) => {
                      return deleteFile(file, fileList, 'mypage1');
                    }
                  "
                  :limit="1"
                >
                  <i slot="trigger" class="el-icon-plus"></i>
                </el-upload>
              </div>
            </div>
            <div>
              <div style="margin-bottom: 5px">
                请上传尺寸为：750x358的图片；
              </div>
              <div style="margin-bottom: 10px">
                <el-upload
                  element-loading-text="正在上传..."
                  action="#"
                  :on-preview="handlePictureCardPreview"
                  :before-upload="
                    (file) => {
                      return handleBeforeUpload(file, 750, 358);
                    }
                  "
                  :class="{ hide: mypage2.length == 1 }"
                  :file-list="mypage2"
                  list-type="picture-card"
                  :http-request="
                    (file) => {
                      return uploadFile(file, 'mypage2');
                    }
                  "
                  :before-remove="
                    (file, fileList) => {
                      return deleteFile(file, fileList, 'mypage2');
                    }
                  "
                  :limit="1"
                >
                  <i slot="trigger" class="el-icon-plus"></i>
                </el-upload>
              </div>
            </div>
          </div>

          <div class="box1-title">通用页面背景图</div>
          <div></div>

          <div style="margin-bottom: 5px">请上传尺寸为：750x128的图片；</div>
          <div style="margin-bottom: 10px">
            <el-upload
              element-loading-text="正在上传..."
              action="#"
              :on-preview="handlePictureCardPreview"
              :before-upload="
                (file) => {
                  return handleBeforeUpload(file, 750, 128);
                }
              "
              :class="{ hide: categorypage.length == 1 }"
              :file-list="categorypage"
              list-type="picture-card"
              :http-request="
                (file) => {
                  return uploadFile(file, 'categorypage');
                }
              "
              :before-remove="
                (file, fileList) => {
                  return deleteFile(file, fileList, 'categorypage');
                }
              "
              :limit="1"
            >
              <i slot="trigger" class="el-icon-plus"></i>
            </el-upload>
          </div>

          <div class="box1-title">活动专区</div>

          <el-button type="primary" @click="hdclick">选择活动模版</el-button>

          <div class="hd-box" v-if="request_data.activity_config_type == 1">
            <div style="margin-bottom: 10px">
              活动1尺寸：412x260 活动2尺寸：262x120 活动3尺寸：262x120
            </div>
            <div style="display: flex">
              <div class="hd-box1" @click="hdpop(1, 412, 260)">+</div>
              <div style="flex: 1">
                <div
                  class="hd-box2"
                  style="margin-bottom: 20px"
                  @click="hdpop(2, 262, 120)"
                >
                  +
                </div>
                <div class="hd-box2" @click="hdpop(3, 262, 120)">+</div>
              </div>
            </div>
          </div>
          <div
            class="hd-box"
            v-else-if="request_data.activity_config_type == 2"
          >
            <div style="margin-bottom: 10px">
              活动1尺寸：412x160 活动2尺寸：262x160
            </div>
            <div style="display: flex">
              <div class="hd-box1" @click="hdpop(1, 412, 160)">+</div>
              <div style="flex: 1">
                <div class="hd-box2" @click="hdpop(2, 262, 160)">+</div>
              </div>
            </div>
          </div>
          <div
            class="hd-box"
            v-else-if="request_data.activity_config_type == 3"
          >
            <div style="margin-bottom: 10px">请上传尺寸为：694x160的图片</div>
            <div style="display: flex">
              <div class="hd-box1" @click="hdpop(1, 694, 160)">+</div>
            </div>
          </div>
        </div>
        <div class="box2">
          <div
            class="bj1"
            :style="{
              backgroundImage: `url(${request_data.homepage_background.url1})`,
            }"
          >
            <img
              style="width: 186px; height: 25px"
              :src="request_data.homepage_background.url3"
              v-if="request_data.homepage_background.url3"
              alt=""
            />
            <div>
              <i class="el-icon-location-outline"></i>
              XXX 仓
            </div>
          </div>
          <div class="cnts">
            <div
              class="bj2"
              :style="{
                backgroundImage: `url(${request_data.homepage_background.url2})`,
              }"
            >
              <el-input placeholder="搜索" prefix-icon="el-icon-search">
              </el-input>

              <el-carousel
                :interval="6000"
                class="carouselhig"
                style="margin-top: 20px"
              >
                <el-carousel-item
                  v-for="(item, index) in tablebannerData"
                  :key="index"
                >
                  <img :src="item.url" alt="" class="imgbanner" />
                </el-carousel-item>
              </el-carousel>
            </div>
            <div class="jgq">
              <el-carousel height="150px" :interval="6000">
                <el-carousel-item
                  v-for="(item, index) in tableDataSwiper"
                  :key="index"
                >
                  <div class="swiper-jgq">
                    <div
                      class="swiper-jgq-item"
                      v-for="item1 in item.data"
                      :key="item1.unique_code"
                    >
                      <img
                        :src="item1.radius_pic"
                        style="
                          width: 40px;
                          height: 40px;
                          border-radius: 50%;
                          object-fit: cover;
                        "
                        alt=""
                      />
                      <div>{{ item1.name }}</div>
                    </div>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>

            <div class="img1" v-if="request_data.activity_config_type == 3">
              <img v-if="hd1" :src="hd1" alt="" />
            </div>
            <div class="img2" v-if="request_data.activity_config_type == 2">
              <img class="imgbox111" v-if="hd1" :src="hd1" alt="" />
              <img class="imgbox222" v-if="hd2" :src="hd2" alt="" />
            </div>
            <div class="img3" v-if="request_data.activity_config_type == 1">
              <div class="img3boxleft">
                <img v-if="hd1" :src="hd1" alt="" />
              </div>
              <div class="img3boxright">
                <img class="yi" v-if="hd2" :src="hd2" alt="" />
                <img class="er" v-if="hd3" :src="hd3" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="box1" style="padding-bottom: 20px">
          <div class="box1-title">金刚区</div>
          <!-- <div style="text-align: right; margin-bottom: 20px">
            <el-button type="primary">排序</el-button>
          </div> -->
          <div class="auto-table-flex">
            <el-table
              :data="tableData"
              height="100%"
              row-key="unique_code"
              ref="draggableTable"
              @row-dragged="handleRowDragged"
              :border="true"
              :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
            >
              <el-table-column
                type="index"
                width="100px"
                align="center"
                label="序号"
              >
              </el-table-column>
              <el-table-column prop="name" align="center" label="品类名称">
              </el-table-column>
              <el-table-column prop="radius_pic" align="center" label="图标">
                <template slot-scope="scope">
                  <el-image
                    style="width: 20px; height: 20px"
                    :src="scope.row.radius_pic"
                    :preview-src-list="[scope.row.radius_pic]"
                  >
                  </el-image>
                  <div>
                    <el-button
                      @click="upimg(scope.row, scope.$index)"
                      type="text"
                      >变更图标</el-button
                    >
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="as_no" align="center" label="操作">
                <template slot-scope="scope">
                  <i class="el-icon-rank"></i>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="选择活动模版"
      :visible.sync="centerDialogVisible"
      v-if="centerDialogVisible"
      width="800px"
      class="dialog"
      center
    >
      <el-carousel
        :autoplay="false"
        :initial-index="initialindex"
        trigger="click"
        @change="changecl"
      >
        <el-carousel-item v-for="(item, index) in 3" :key="index">
          <div class="hd-box" v-if="item == 1">
            <div style="margin-bottom: 10px">
              活动1尺寸：412x260 活动2尺寸：262x120 活动3尺寸：262x120
            </div>
            <div style="display: flex">
              <div class="hd-box1">+</div>
              <div style="flex: 1">
                <div class="hd-box2" style="margin-bottom: 20px; height: 60px">
                  +
                </div>
                <div class="hd-box2" style="height: 60px">+</div>
              </div>
            </div>
          </div>
          <div class="hd-box" v-else-if="item == 2">
            <div style="margin-bottom: 10px">
              活动1尺寸：412x160 活动2尺寸：262x160
            </div>
            <div style="display: flex; height: 140px">
              <div class="hd-box1">+</div>
              <div style="flex: 1">
                <div class="hd-box2" style="height: 100%">+</div>
              </div>
            </div>
          </div>
          <div class="hd-box" v-else-if="item == 3">
            <div style="margin-bottom: 10px">请上传尺寸为：694x160的图片</div>
            <div style="display: flex; height: 140px">
              <div class="hd-box1" style="flex: 1">+</div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="hdmb">保存当前模版</el-button>
      </span>
    </el-dialog>

    <iconPopUpfrom
      ref="iconPopUpfromref"
      @imgchange="imgchange"
      
    ></iconPopUpfrom>
    <hdPopUpfrom ref="hdPopUpfromref"  @hdchange="hdchange"></hdPopUpfrom>
  </div>
</template>
<script>
import Sortable from "sortablejs";
import { postBannerUpload } from "@/api/generalControl/banner";
import iconPopUpfrom from "./component/icon-pop-up.vue";
import hdPopUpfrom from "./component/hd-pop-up.vue";
import { compress } from "image-conversion";
export default {
  components: { iconPopUpfrom, hdPopUpfrom },
  props: {
    type: {
      type: String,
      default: [],
    },
  },
  computed: {
    /**
     * 金刚区滚动数据
     */
    tableDataSwiper() {
      /** 将数据分为三个区域 */
      const list = [
        {
          data: this.tableData.slice(0, this.rowX * this.rowY) || [],
        },
        {
          data:
            this.tableData.slice(
              this.rowX * this.rowY,
              this.rowX * this.rowY * 2
            ) || [],
        },
        {
          data:
            this.tableData.slice(
              this.rowX * this.rowY * 2,
              this.rowX * this.rowY * 4
            ) || [],
        },
      ];
      /** 过滤掉空数据 */
      const res = list.filter((child) => child.data.length);
      return res;
    },
  },
  data() {
    return {
      initialindex: 0,
      centerDialogVisible: false,
      rowX: 5, // 横向最大展示多少个
      rowY: 2, // 纵向最多几行
      homepage1: [],
      homepage2: [],
      homepage3: [],
      hd1: "",
      hd2: "",
      hd3: "",
      categorypage: [],
      mypage1: [],
      mypage2: [],
      tableData: [],
      tablebannerData: [], //分类配置
      sortable: "",
      imgindex: "",
      request_data: {
        homepage_background: {
          url1: "",
          url2: "",
          url3: "",
        }, //首页背景配置
        categorypage_background: {
          url: "",
        }, //分类页背景配置
        mypage_background: {
          url1: "",
          url2: "",
        }, //我的页面背景配置
        activity_config_type: 0, //活动模版 0=无配置 1=样式1 2=样式2 3=样式3
        activity_config_data: {
          data_one: {
            url: "",
            id: "",
            href: "",
          },
          data_two: {
            url: "",
            id: "",
            href: "",
          },
          data_three: {
            url: "",
            id: "",
            href: "",
          },
        }, //活动数据
        category_data: [], //分类配置
      },
    };
  },
  created() {
    this.hqinfo();
    this.getbannerlist();
    this.$nextTick(() => {
      this.initSortable();
    });
  },
  beforeDestroy() {
    // 销毁Sortable实例防止内存泄漏
    if (this.sortable) {
      this.sortable.destroy();
    }
  },
  methods: {
    hdchange(type, obj) {
      if (type == 1) {
        this.request_data.activity_config_data.data_one = obj;
          this.hd1 = obj.url;
      } else if (type == 2) {
        this.request_data.activity_config_data.data_two = obj;
          this.hd2 = obj.url;
      } else if (type == 3) {
        this.request_data.activity_config_data.data_three = obj;
          this.hd3 = obj.url;
      }
      
    },
    hdmb() {
      this.centerDialogVisible = false;
      if (this.request_data.activity_config_type != this.initialindex + 1) {
        this.request_data.activity_config_data = {
          data_one: {
            url: "",
            id: "",
            href: "",
          },
          data_two: {
            url: "",
            id: "",
            href: "",
          },
          data_three: {
            url: "",
            id: "",
            href: "",
          },
        };
        this.hd1 = "";
        this.hd2 = "";
        this.hd3 = "";
      }
      this.request_data.activity_config_type = this.initialindex + 1;
    },
    changecl(e) {
      console.log(e, "11111111");

      this.initialindex = e;
    },
    hdclick() {
      this.initialindex =
        this.request_data.activity_config_type == 0
          ? 0
          : this.request_data.activity_config_type - 1;
      this.centerDialogVisible = true;
    },
    imgchange(e) {
      this.tableData[this.imgindex].radius_pic = e.url;
    },
    upimg(e, i) {
      console.log(e, i);
      this.imgindex = i;
      this.$refs.iconPopUpfromref.oninit(e);
    },
    hdpop(type, w, h) {
      this.$refs.hdPopUpfromref.oninit(
        type,
        w,
        h,
        this.request_data.activity_config_data,
        this.type
      );
    },
    getbannerlist() {
      this.$api.ren
        .bannerlist({
          business_id: this.type,
        })
        .then((res) => {
          console.log(res, "初始化分类数据");
          this.tablebannerData = res.data;
        });
    },
    save() {


      if(this.request_data.activity_config_type==1){
        console.log(111111111,this.hd1)
if(!this.hd1||!this.hd2||!this.hd3){
   this.$message({
            type: "error",
            message: "请配置活动项",
          });
          return;
}
      }else if(this.request_data.activity_config_type==2){
if(!this.hd1 || !this.hd2){
   this.$message({
            type: "error",
            message: "请配置活动项",
          });
             return;
}
      }else if(this.request_data.activity_config_type==3){
        if(!this.hd1){
   this.$message({
            type: "error",
            message: "请配置活动项",
          });
             return;
}
      }




      this.$confirm("是否保存此样式?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.request_data.category_data = this.tableData;
          this.$api.ren
            .configsetting({
              request_data: this.request_data,
              business_id: this.type,
            })
            .then((res) => {
              this.$message({
                type: "success",
                message: "保存成功!",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 上传前校验 —— 限制图片尺寸
    handleBeforeUpload(file, w, h) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);

        img.onload = () => {
          // 在这里设置你要的宽高限制
          const width = img.width;
          const height = img.height;

          // ========== 示例1：限制必须是 300x300 ==========
          if (width !== w || height !== h) {
            this.$message.error(`图片尺寸必须是 ${w}px × ${h}px`);
            reject(false);
            return;
          }

          // 校验通过
          resolve(true);
        };
      });
    },
    deleteFile(file, fileList, name) {
      console.log(file, "删除");
      console.log(fileList, "删除");
      // this[name] = fileList;

      if (name == "homepage1") {
        this[name] = fileList;
        this.request_data.homepage_background.url1 = "";
      } else if (name == "homepage2") {
        this[name] = fileList;
        this.request_data.homepage_background.url2 = "";
      } else if (name == "homepage3") {
        this[name] = fileList;
        this.request_data.homepage_background.url3 = "";
      } else if (name == "categorypage") {
        this[name] = fileList;
        this.request_data.categorypage_background.url = "";
      } else if (name == "mypage1") {
        this[name] = fileList;
        this.request_data.mypage_background.url1 = "";
      } else if (name == "mypage2") {
        this[name] = fileList;
        this.request_data.mypage_background.url2 = "";
      }
      //   this.ruleForm[name] = fileList;
    },
    uploadFile(options, name) {
      // 拿到 file

      let file = options.file;
      let date = new Date().getTime();
      console.log(file, "文件");
      console.log(file.size / 1024 / 1024);
      compress(file, 0.9).then((res) => {
        console.log(res);
        console.log(res.size / 1024 / 1024);
        if (res.size / 1024 / 1024 > 50) {
          this.tool.message("图片超过50M,请重新上传", "error");
          //   this.loadingImage = false;
        } else {
          var event = event || window.event;
          var reader = new FileReader();
          reader.readAsDataURL(res);
          reader.onload = (e) => {
            console.log(e);
            this.uploadImage(e.target.result, name);
          };
        }
      });
    },
    async uploadImage(img, name) {
      try {
        let { data } = await postBannerUpload({ file_data: img });

        if (name == "homepage1") {
          this[name] = [{ url: data }];
          this.request_data.homepage_background.url1 = data;
        } else if (name == "homepage2") {
          this[name] = [{ url: data }];
          this.request_data.homepage_background.url2 = data;
        } else if (name == "homepage3") {
          this[name] = [{ url: data }];
          this.request_data.homepage_background.url3 = data;
        } else if (name == "categorypage") {
          this[name] = [{ url: data }];
          this.request_data.categorypage_background.url = data;
        } else if (name == "mypage1") {
          this[name] = [{ url: data }];
          this.request_data.mypage_background.url1 = data;
        } else if (name == "mypage2") {
          this[name] = [{ url: data }];
          this.request_data.mypage_background.url2 = data;
        }
      } catch (error) {
        console.error("ajax postBannerUpload err", err);
      } finally {
        // this.loadingImage = false;
      }
    },
    handlePictureCardPreview(file) {
      console.log("object", file);
    },
    handleRowDragged(newData) {
      this.tableData = newData; // 如果需要更新视图或其他操作可以在这里处理
    },
    initSortable() {
      console.log(this.$refs.draggableTable);
      const el = this.$refs.draggableTable.$el.querySelector(
        ".el-table__body-wrapper tbody"
      );
      this.sortable = Sortable.create(el, {
        onEnd: (evt) => {
          const { newIndex, oldIndex } = evt;
          const movedItem = this.tableData.splice(oldIndex, 1)[0];
          this.tableData.splice(newIndex, 0, movedItem);
        },
      });
    },
    hqinfo() {
      this.$api.ren
        .configinfo({
          business_id: this.type,
        })
        .then((res) => {
          console.log(res, "获取详情");
          this.request_data = res.data.length==0?this.request_data:res.data;
          if (this.request_data.homepage_background) {
            this.homepage1 = this.request_data.homepage_background.url1
              ? [{ url: this.request_data.homepage_background.url1 }]
              : [];
            this.homepage2 = this.request_data.homepage_background.url2
              ? [{ url: this.request_data.homepage_background.url2 }]
              : [];
            this.homepage3 = this.request_data.homepage_background.url3
              ? [{ url: this.request_data.homepage_background.url3 }]
              : [];
          }
          if (this.request_data.categorypage_background) {
            this.categorypage = this.request_data.categorypage_background.url
              ? [{ url: this.request_data.categorypage_background.url }]
              : [];
          }
          if (this.request_data.mypage_background) {
            this.mypage1 = this.request_data.mypage_background.url1
              ? [{ url: this.request_data.mypage_background.url1 }]
              : [];
            this.mypage2 = this.request_data.mypage_background.url2
              ? [{ url: this.request_data.mypage_background.url2 }]
              : [];
          }
          if (this.request_data.activity_config_data) {
            this.hd1 = this.request_data.activity_config_data.data_one.url
              ? this.request_data.activity_config_data.data_one.url
              : "";
            this.hd2 = this.request_data.activity_config_data.data_two.url
              ? this.request_data.activity_config_data.data_two.url
              : "";
            this.hd3 = this.request_data.activity_config_data.data_three.url
              ? this.request_data.activity_config_data.data_three.url
              : "";
          }
          console.log(this.hd1, "1111");
          if (res.data.length==0||res.data.category_data.length == 0) {
            this.getfirstcategory();
          } else {
            this.tableData = res.data.category_data;
          }
        });
    },
    getfirstcategory() {
      this.$api.ren
        .firstcategory({
          business_id: this.type,
        })
        .then((res) => {
          console.log(res, "初始化分类数据");
          this.tableData = res.data;
        });
    },
  },
};
</script>
<style lang="less">
.homepage {
  height: 100%;
  padding: 30px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  .img1 {
    padding: 20px;
    padding-top: 0;
    box-sizing: border-box;
    img {
      width: 100%;
      height: 80px;
      object-fit: fill;
    }
  }
  .img2 {
    display: flex;
    padding: 20px;
    padding-top: 0;
    box-sizing: border-box;
    .imgbox111 {
      width: 207px;
      height: 80px;
      margin-right: 20px;
      object-fit: fill;
    }
    .imgbox222 {
      flex: 1;
      height: 80px;
    object-fit: fill;
    }
  }
  .img3 {
    display: flex;
    padding: 20px;
    padding-top: 0;
    box-sizing: border-box;
    .img3boxleft {
      height: 130px;
      margin-right: 20px;
      img {
        width: 100%;
        height: 100%;
        object-fit: fill;
      }
    }
    .img3boxright {
      flex: 1;
      .yi {
        height: 60px;
        margin-bottom: 10px;
        object-fit: fill;
      }
      .er {
        height: 60px;
        object-fit: fill;
      }
    }
  }
  .hide {
    .el-upload--picture-card {
      display: none;
    }
  }
  .carouselhig {
    height: 150px;
    .el-carousel__container {
      height: 100%;
    }
  }
  .imgbanner {
    width: 100%;
    // height: 200px;
    object-fit: fill;
  }
  .hd-box {
    // display: flex;
    background-color: #989898;
    margin-top: 30px;
    border-radius: 10px;
    padding: 20px;
    box-sizing: border-box;
    .hd-box1 {
      width: 206px;
      margin-right: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #fff;
      font-size: 30px;
    }
    .hd-box2 {
      flex: 1;
      // height: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #fff;
      font-size: 30px;
    }
  }
  .btn {
    margin-bottom: 20px;
  }
  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
    .homepagecnt {
      height: 100%;
      display: flex;
      align-items: center;
      gap: 30px;
      .box1 {
        flex: 1;
        height: 100%;
        overflow-y: auto;
        background-color: #fff;
        padding: 20px;
        padding-bottom: 300px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        .box1-title {
          font-size: 24px;
          margin-bottom: 10px;
        }
      }
      .box2 {
        width: 500px;
        height: 100%;

        background-color: #fff;

        .bj1 {
          width: 100%;
          height: 128px;
          background-size: 100% 100%;
          padding: 50px 0 0 20px;
          box-sizing: border-box;
        }
        .cnts {
          height: calc(100% - 128px);
          overflow-y: auto;
          -ms-overflow-style: none; /* IE 10+ */
          scrollbar-width: none; /* Firefox */
          .bj2 {
            width: 100%;
            height: 300px;
            padding: 20px;
            box-sizing: border-box;
            background-size: 100% 100%;
          }
          .swiper-jgq {
            display: flex;
            // align-items: center;
            flex-wrap: wrap;
            height: 100%;
            .swiper-jgq-item {
              width: 20%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              margin-bottom: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
